export default "__VITE_ASSET__CdWPK5aj__"